import { useEffect } from "react";

const clean=(value:string|null|undefined)=>(value||"").replace(/\s+/g," ").trim().toLowerCase();

export default function WeldRegisterMetricFilter(){
  useEffect(()=>{
    const bind=()=>{
      document.querySelectorAll<HTMLElement>(".weld-register").forEach(section=>{
        const metrics=section.querySelector<HTMLElement>(".weld-register-metrics");
        const table=section.querySelector<HTMLTableElement>("table");
        if(!metrics||!table)return;

        const cards=[...metrics.querySelectorAll<HTMLElement>(":scope > span")];
        cards.forEach(card=>{
          if(card.dataset.weldFilterBound)return;
          card.dataset.weldFilterBound="true";
          card.style.cursor="pointer";
          card.tabIndex=0;
          card.setAttribute("role","button");

          const apply=()=>{
            const label=clean(card.querySelector("small")?.textContent);
            const rows=[...table.querySelectorAll<HTMLTableRowElement>("tbody tr")];
            rows.forEach(row=>{
              const text=clean(row.textContent);
              let show=true;
              if(label.includes("accepted")) show=text.includes("accepted");
              else if(label.includes("pending")) show=!text.includes("accepted")&&!text.includes("hold")&&!text.includes("open ncr");
              else if(label.includes("hold")) show=text.includes("hold")||text.includes("open ncr");
              row.style.display=show?"":"none";
            });
            cards.forEach(x=>x.classList.toggle("weld-metric-selected",x===card));
          };

          card.addEventListener("click",apply);
          card.addEventListener("keydown",e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();apply()}});
        });
      });
    };

    bind();
    const observer=new MutationObserver(bind);
    observer.observe(document.body,{childList:true,subtree:true});
    return()=>observer.disconnect();
  },[]);
  return null;
}
